exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3vFK2WYIU1tU6LhsJmNmGZ {\n  display: flex;\n  flex-direction: column;\n  padding: 0 5px;\n}\n\n._2pd6eTcTvU6e5dBVyNxIGT {\n  margin-bottom: 12px;\n}\n\n.lQDs1KRgf9StI9EjesaZP {\n  display: flex;\n  gap: 8px;\n}\n\n.lQDs1KRgf9StI9EjesaZP > * {\n  flex: 1;\n  min-width: 0;\n}\n\n._1Lv9i8oJBr2kBrfm9GaMtj {\n  padding-bottom: 16px;\n}\n\n._1p8SIExP8vFGaKGIdtEVen {\n  padding: 16px;\n  margin-bottom: 4px;\n  border-radius: 4px;\n  background-color: var(--light-danger-color);\n}\n\n._2lCgWMOjsmvlpTXld041rg {\n  display: flex;\n  gap: 8px;\n  padding: 12px 0 16px;\n}\n\n._3uaCBpgV-vkqXf3uOIm4dg {\n  margin-top: 4px;\n  font-size: 12px;\n  color: var(--heavy-warning-color);\n}\n", ""]);

// Exports
exports.locals = {
	"form": "_3vFK2WYIU1tU6LhsJmNmGZ",
	"title": "_2pd6eTcTvU6e5dBVyNxIGT",
	"row": "lQDs1KRgf9StI9EjesaZP",
	"field": "_1Lv9i8oJBr2kBrfm9GaMtj",
	"errorBanner": "_1p8SIExP8vFGaKGIdtEVen",
	"buttons": "_2lCgWMOjsmvlpTXld041rg",
	"warningText": "_3uaCBpgV-vkqXf3uOIm4dg"
};